/* eslint-disable */
import store from '@/store';
import router from '@/router';
import { callAPIPersisted } from '@/persistedQueue';
import { publishLocal } from '@/store/socket';
import { getScreenDevices, getTronDisplayMedia, saveTaskToLocalStorage } from './store/utils';
import indexedDB from '@/utils/indexedDB';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { sneakyPromise } from './store/profiling';

dayjs.extend(utc);


let ipcRenderer;
if (window.APP_TRON) {
  // eslint-disable-next-line prefer-destructuring
  ipcRenderer = window.APP_TRON.ipcRenderer;
  ipcRenderer.on('resize-window', async (_, data) => {
    indexedDB.saveData({
      data,
      dataId: 'size-window',
      dbName: 'commonSpace',
    });
  });
  ipcRenderer.on('maximize-window', async (_, data) => {
    indexedDB.saveData({
      data,
      dataId: 'maximize-window',
      dbName: 'commonSpace',
    });
  });
  ipcRenderer.on('gotWin', (_, win) => {
    if (!state.windows) {
      state.windows = {};
    }
    state.windows[win.name] = state.windows[win.name] ? state.windows[win.name] + 1 : 1;
    state.capturedTitle = win.title;
  });
}

const SCREENSHOTS_INTERVAL_SECONDS = 10 * 60;
const APPROVE_VIEW_TIME = 10;

const SCREENSHOT_FORMAT = 'image/webp'; // todo: why not webp, create task and convert
const SCREENSHOT_QUALITY = 0.1;
const THUMBNAIL_QUALITY = 0.5;
const SENSITIVE_SCREENSHOT_ROUTES = new Set(['profit-share', 'salary', 'invoice-generator']);
const SENSITIVE_SCREENSHOT_MAX_DIMENSION = 300;

const PC_ALLOW_LAG_SECONDS = 8;
const BUILT_APP_HASH = 'TODO'; // TODO

const START_IDLE = 'start';
const STOP_IDLE = 'stop';

const IDLE_TIME = 8 * 60000; // 8 minutes

// const stateProject = store.state.project;

const state = {
  task: null,
  actualTimeSeconds: null,
  activeTimeSlot: null,
  slotProgresses: null,
  lastRealCheck: null,
  trackingContext: {
    displayStream: null,
    nowUTC: dayjs.utc(),
    now: performance.now(),
  },
  idle: {
    controller: null,
    detector: null,
    signal: null,
    activity: null,
    takeLastIdle: false,
  },
  screenshotsEnabled: true,
};

window.trackingContext = state.trackingContext;

function getTrackingContextNow() {
  if (localStorage.getItem('timeTrackingClock') === 'monotonic') {
    return trackingContext.now;
  }
  return trackingContext.nowUTC;
}

async function initializeTracking() {
  if (state.trackingContext.initialized) {
    console.log('🐕‍🦺 Tracking already initialized in current worker run, skipping');
    return;
  }
  console.log(new Date().toISOString(), '🐕‍🦺 Initializing tracking');

  setInterval(() => {
    trackingContext.nowUTC = store.state.system.nowUTC;
  }, 500);
  setInterval(() => {
    trackingContext.now = performance.now();
  }, 500);
  await indexedDB.init(); // offline requests and size app window
}

const idleController = action => {
  if (action === START_IDLE) {
    state.idle.controller = new AbortController();
    state.idle.signal = state.idle.controller.signal;
    state.idle.detector = new IdleDetector();
    state.idle.activity = new IdleDetector();
    console.log('Start checking idle');
    state.idle.detector.start({
      threshold: IDLE_TIME,
      signal: state.idle.signal,
    });
    if (!window.APP_TRON) {
      state.idle.activity = new IdleDetector();
      state.idle.activity.start({
        threshold: 60000,
        signal: state.idle.signal,
      });
    }
  }

  if (action === STOP_IDLE) {
    console.log('Stop checking idle');
    if (state.idle.controller) {
      state.idle.controller.abort();
    }
    state.idle.controller = null;
    state.idle.signal = null;
    state.idle.detector = null;
    state.idle.activity = null;
  }
};

const checkNotifyPermission = async () => {
  const result = await Notification.requestPermission();
  return result === 'granted';
};

const checkIdlePermission = async () => {
  try {
    const result = await IdleDetector.requestPermission();
    console.log('checkIdlePermission => ', result);
    return result === 'granted';
  } catch (e) {
    console.log('checkIdlePermission error => ', e);
    return false;
  }
};

function randBM() {
  // Box–Muller transform to give normal distribution between 0 and 1 inclusive
  let u = 0;
  let v = 0;
  while (u === 0) {
    u = Math.random(); // Converting [0,1) to (0,1)
  }
  while (v === 0) {
    v = Math.random();
  }
  let num = Math.sqrt(-2.0 * Math.log(u)) * Math.cos(2.0 * Math.PI * v);
  num = num / 10.0 + 0.5; // Translate to 0 -> 1
  if (num > 1 || num < 0) {
    return randnBM(); // resample between 0 and 1
  }
  return num;
}

let doScreenshot;

function scheduleNextScreenshot(lastTimeSlot) {
  let pannedSecond;
  if (!lastTimeSlot || lastTimeSlot.capturedAt) {
    pannedSecond = SCREENSHOTS_INTERVAL_SECONDS * randBM() * 2;
    pannedSecond = Math.max(pannedSecond, APPROVE_VIEW_TIME + 1);
  } else {
    pannedSecond = lastTimeSlot.plannedTimeSeconds - lastTimeSlot.actualTimeSeconds;
  }
  const plannedTimeSeconds = pannedSecond;
  const timeSlotStart = trackingContext.nowUTC.toISOString();

  if (!state.task) {
    throw new Error("Can't schedulle screenshot - no task tracked, please start tracking");
  }

  const ttbu = state.task.taskTrackedByUsers.find(t => t.userId === state.user.id);
  if (!ttbu) {
    console.log(
      `🐕‍🦺 🔴🔴🔴 trackingEngine - Can't schedulle screenshot - No ttbu for task ${state.task.id} and user ${state.user.id}`,
    );
    return null;
  }

  if (lastTimeSlot) {
    // the slot comes from the server: input and titlesList are JSON strings there and the ids may be missing
    const parseJsonField = (value, empty) => {
      if (!value) return empty;
      return typeof value === 'string' ? JSON.parse(value) : value;
    };
    const prevTimeSlot = {
      ...lastTimeSlot,
      input: parseJsonField(lastTimeSlot.input, { inactive: 0 }),
      titlesList: parseJsonField(lastTimeSlot.titlesList, {}),
      taskId: state.task.id,
      userId: state.user.id,
      taskTrackedByUserId: ttbu.id,
      projectId: state.task.projectId, // todo: only for legacy timeslots
    };
    const isSameDate = dayjs(lastTimeSlot.createdAt)
      .utc()
      .isSame(trackingContext.nowUTC, 'day');
    if (isSameDate) {
      state.activeTimeSlot = prevTimeSlot;
      state.windows = prevTimeSlot.titlesList;
    } else {
      const sentSlot = prevTimeSlot;
      state.activeTimeSlot = {
        id: window.utils.genId(),
        taskId: state.task.id,
        projectId: state.task.projectId,
        userId: state.user.id,
        taskTrackedByUserId: ttbu.id,
        plannedTimeSeconds,
        actualTimeSeconds: 0,
        createdAt: timeSlotStart,
        trackStarted: timeSlotStart,
        input: { inactive: 0 },
        titlesList: {},
      };
      delete ttbu.timeSlots;
      ttbu.totalSeconds += sentSlot.actualTimeSeconds;

      publishLocal({
        event: 'updateTTBU',
        data: {
          ttbu,
        },
      });
      publishLocal({
        event: 'updateTimeSlot',
        note: 'old slot is deprecated',
        data: state.activeTimeSlot,
      });
      callAPIPersisted('completeTimeSlot', {
        timeSlot: sentSlot,
        newTimeSlot: state.activeTimeSlot,
        source: 'scheduleNextScreenshot',
      });
    }
  } else {
    // back will generate ttbuId for us, but need for better consistency when tracked offline
    state.activeTimeSlot = {
      id: window.utils.genId(),
      taskId: state.task.id,
      projectId: state.task.projectId,
      userId: state.user.id,
      taskTrackedByUserId: ttbu.id,
      plannedTimeSeconds,
      actualTimeSeconds: 0,
      createdAt: timeSlotStart,
      input: { inactive: 0 },
    };
  }
  state.activeTimeSlot.trackStarted = timeSlotStart;

  if (state.activeTimeSlot.input && !state.activeTimeSlot.input.inactive) {
    state.activeTimeSlot.input.inactive = 0;
  }

  console.log('🐕‍🦺 scheduleNextScreenshot / persisting slot', state.activeTimeSlot);

  if (state.slotProgresses) {
    clearInterval(state.slotProgresses);
  }

  state.lastRealCheck = getTrackingContextNow();


  const calculateInactivity = async (time) => {
    const idleTime = window.APP_TRON ? 10 : 60;
    const checkUnlessMoreTime = () => {
      if (state.activeTimeSlot.input?.inactive > state.activeTimeSlot.actualTimeSeconds) {
        state.activeTimeSlot.input.inactive = Math.floor(state.activeTimeSlot.actualTimeSeconds);
      }
    };

    const addInactivity = () => {
      try {
        if (state.idle.takeLastIdle) {
          console.log('👁👁 => Start idle counter');
          state.activeTimeSlot.input.inactive = Math.ceil((state.activeTimeSlot.input.inactive ?? 0) + idleTime);
          state.idle.takeLastIdle = false;
        } else {
          state.activeTimeSlot.input.inactive = Math.ceil((state.activeTimeSlot.input.inactive ?? 0) + time);
        }
        checkUnlessMoreTime();
      } catch (e) {
        if (state.activeTimeSlot.input) {
          state.activeTimeSlot.input.inactive = 0;
        }
        console.log('⛔️⛔️⛔️ => ', e);
      }
    };

    if (window.APP_TRON) {
      state.activeTimeSlot.titlesList = { ...state.windows };
    }
    const idleInWeb = (state.idle.activity?.userState === 'idle' && !window.APP_TRON);
    const idleInApp = (window.APP_TRON && window.APP_TRON.getSystemIdleState
      && await window.APP_TRON.getSystemIdleState(idleTime) === 'idle');

    if (idleInWeb || idleInApp) {
      addInactivity();
      return;
    }

    state.idle.takeLastIdle = true;
  };

  state.slotProgresses = setInterval(async () => {
    const now = getTrackingContextNow();
    const { lastRealCheck } = state;
    if ((now - lastRealCheck) / 1000.0 < PC_ALLOW_LAG_SECONDS) {
      // if not from sleep/ not lagged
      const timeToAdd = Math.max((now - lastRealCheck) / 1000.0, 0);
      state.activeTimeSlot.actualTimeSeconds = state.activeTimeSlot.actualTimeSeconds + timeToAdd;
      state.lastRealCheck = now;

      await calculateInactivity(timeToAdd);
      if (state.activeTimeSlot.actualTimeSeconds >= state.activeTimeSlot.plannedTimeSeconds) {
        doScreenshot().catch(e => {
          console.log('🔴🔴🔴 doScreenshot failed, skipping this screenshot =>', e);
        });
      }
    } else {
      console.log(
        '🔴🔴🔴 Slot progresses screwed up. Now:',
        now,
        'lastRealCheck:',
        lastRealCheck,
        now - lastRealCheck,
      );
      store.dispatch('task/stopTracking', { action: 'time' });
    }
  }, 500);

  // Update timeSlot in localStore 'LAST_TASK'
  (() => {
    try {
      const lastTask = JSON.parse(localStorage.getItem('LAST_TASK'));
      if (!lastTask) return;

      const ttbu = lastTask.taskTrackedByUsers.find(ttbu => ttbu.userId === store.state.user?.user?.id);
      if (!ttbu) return;

      ttbu.timeSlots ??= [];
      ttbu.timeSlots[0] = state.activeTimeSlot;

      saveTaskToLocalStorage(lastTask);
    } catch (e) {
      console.error('Failed to update timeSlot in LAST_TASK', e);
    }
  })();

  return state.activeTimeSlot;
}

async function electronFullScreenScreenshot() {
  if (!state.trackingContext.displayStream) {
    return await electronFullScreenScreenshotLegacy();
  }

  const imageData = await fullScreenScreenshot(15000);
  return {
    imageDataUrl: imageData.imageDataUrl,
    images: [imageData.imageDataUrl],
  };
}

async function electronFullScreenScreenshotLegacy() {
  const screenIds = await getScreenDevices();
  const screens = await Promise.all(
    screenIds.map(async screenId => {
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: false,
        video: {
          mandatory: {
            chromeMediaSource: 'desktop',
            chromeMediaSourceId: screenId,
            maxFrameRate: 1,
          },
        },
      });

      const video = document.createElement('video');
      video.style.cssText = 'position:absolute;top:-10000px;left:-10000px;';
      document.body.appendChild(video);

      try {
        video.srcObject = stream;
        const { videoWidth, videoHeight } = await sneakyPromise((resolve, reject) => {
          video.onloadedmetadata = function () {
            resolve({ videoWidth: this.videoWidth, videoHeight: this.videoHeight });
          };
          setTimeout(() => reject(new Error('Timeout loading metadata in doing screenshot')), 15000);
        });

        video.height = videoHeight;
        video.width = videoWidth;
        const canvas = new OffscreenCanvas(videoWidth, videoHeight);
        const ctx = canvas.getContext('2d');
        await video.play();
        ctx.drawImage(video, 0, 0, videoWidth, videoHeight);
        return canvas;
      } finally {
        stream.getTracks().forEach(track => track.stop());
        video.pause();
        video.srcObject = null;
        video.remove();
      }
    }),
  );

  const width = screens.reduce((sum, screen) => sum + screen.width, 0);
  const height = screens.reduce((max, screen) => Math.max(max, screen.height), 0);
  const canvas = new OffscreenCanvas(width, height);
  const ctx = canvas.getContext('2d');

  let xOffset = 0;
  screens.forEach(screen => {
    ctx.drawImage(screen, xOffset, 0);
    xOffset += screen.width;
  });

  const images = await Promise.all(
    screens.map(async screen => {
      const data = await screen.convertToBlob({
        type: SCREENSHOT_FORMAT,
        quality: SCREENSHOT_QUALITY,
      });
      const dataBuffer = await data.arrayBuffer();
      return `data:${SCREENSHOT_FORMAT};base64,${Buffer.from(dataBuffer).toString('base64')}`;
    }),
  );

  const dataBlob = await canvas.convertToBlob({
    type: SCREENSHOT_FORMAT,
    quality: SCREENSHOT_QUALITY,
  });
  const dataBuffer = await dataBlob.arrayBuffer();
  const imageDataUrl = `data:${SCREENSHOT_FORMAT};base64,${Buffer.from(dataBuffer).toString('base64')}`;

  return { imageDataUrl, images };
}

function stopDisplayStream() {
  const displayStream = state.trackingContext.displayStream;
  if (!displayStream) {
    return;
  }

  displayStream.oninactive = null;
  displayStream.getTracks().forEach(track => {
    track.onended = null;
    track.stop();
  });
  state.trackingContext.displayStream = null;
}

function bindDisplayStreamLifecycle(displayStream) {
  let handled = false;

  const onStreamInactive = async reason => {
    if (handled) {
      return;
    }
    handled = true;

    console.log('😢 displayStream.oninactive', reason);

    if (store.state.task.isForceStop) {
      console.log('Is force stopped');
      return;
    }

    if (store.state.task.isManualStop) {
      console.log('Is manual stopped');
      return;
    }

    await store.dispatch('task/stopTracking', { action: 'click_stop_share' });

    if (!window.APP_TRON && store.state.project?.taskUnderEdit) {
      const result = window.confirm(
        'Browser interrupted screen sharing so we stopped tracking. Resume tracking?',  // ToDo : localize
      );
      if (result) {
        store.dispatch('task/startTracking', { task: store.state.project.taskUnderEdit, retry: true });
      }
    }
  };

  displayStream.oninactive = onStreamInactive;
  displayStream.getVideoTracks().forEach(track => {
    track.onended = () => onStreamInactive(`track-ended:${track.id}`);
  });
}

async function initializeElectronDisplayStream() {
  if (state.trackingContext.displayStream) {
    return state.trackingContext.displayStream;
  }

  const isWaylandTracking = window.APP_TRON?.isWayland;
  const displayStream = await getTronDisplayMedia({
    sourceTypes: ['screen'],
    ...(isWaylandTracking ? {
      // On Wayland tracking we auto-select the single screen source anyway, so
      // thumbnails only add extra portal/UI work. Keep X11 thumbnails intact for
      // the HTML picker when multiple displays are available there.
      thumbnailSize: { width: 0, height: 0 },
    } : {}),
  });
  state.trackingContext.displayStream = displayStream;
  bindDisplayStreamLifecycle(displayStream);
  return displayStream;
}

async function initializeNativeDisplayStream() {
  // used by browser and native mac electron
  const reusedExistingStream = !!state.trackingContext.displayStream;
  console.log('🩺SCAP_DIAG initializeNativeDisplayStream: reusedExistingStream=', reusedExistingStream, 'platform=', window.devicePlatform, 'APP_TRON=', !!window.APP_TRON);
  if (!state.trackingContext.displayStream) {
    console.log('🩺SCAP_DIAG calling getDisplayMedia (no existing stream)…');
    state.trackingContext.displayStream = await navigator.mediaDevices.getDisplayMedia({
      video: {
        displaySurface: 'monitor',
        frameRate: {
          ideal: 20,
          max: 24,
        },
      },
    });
    console.log('🩺SCAP_DIAG getDisplayMedia resolved');
  }

  const videoTrack = state.trackingContext.displayStream.getVideoTracks()[0];
  const device = videoTrack.getSettings();
  console.log('🩺SCAP_DIAG track state: readyState=', videoTrack.readyState, 'enabled=', videoTrack.enabled, 'muted=', videoTrack.muted, 'settings=', JSON.stringify(device));

  if (window.devicePlatform !== 'darwin' && device.displaySurface !== 'monitor') {
    // On macOS getDisplayMedia can report displaySurface as "window" even when the
    // user selected the full screen in the native picker, so this validation is
    // currently only reliable outside macOS.
    console.log('🔴🔴🔴 displaySurface is not monitor, stopping tracking', {deviceDisplaySurface: device.displaySurface, device});
    store.commit('task/setMetaNotify', device.displaySurface);
    deactivateTracking();
    return 'RETRY';
  }

  bindDisplayStreamLifecycle(state.trackingContext.displayStream);
  return state.trackingContext.displayStream;
}


async function fullScreenScreenshot(metadataTimeoutMs = 1000) {
  const video = document.createElement('video');
  video.style.cssText = 'position:absolute;top:-10000px;left:-10000px;';
  document.body.appendChild(video);
  let metadataTimeout;
  try {
    await sneakyPromise((resolve, reject) => {
      video.onloadedmetadata = resolve;
      metadataTimeout = setTimeout(() => reject(new Error('Timeout loading image in doing screenshot')), metadataTimeoutMs);
      video.srcObject = state.trackingContext.displayStream;
    });
    clearTimeout(metadataTimeout);
    // Set video ORIGINAL height (screenshot)
    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext('2d');
    console.log('working => 1');
    await video.play();
    console.log('working => 2');
    // Draw video on canvas
    console.log('ctx.drawImage', video.videoWidth, video.videoHeight);
    ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);

    // toDataURL is much faster then convertToBlob https://stackoverflow.com/a/57966833/3479125
    // thats why we don't use OffscreanCanvas
    const imageDataUrl = canvas.toDataURL(SCREENSHOT_FORMAT, SCREENSHOT_QUALITY);
    return { imageDataUrl };
  } finally {
    clearTimeout(metadataTimeout);
    video.onloadedmetadata = null;
    video.pause();
    video.srcObject = null;
    video.remove();
  }
}

async function loadScreenshotImage(base64Str) {
  const img = new Image();
  await sneakyPromise((resolve, reject) => {
    img.onload = resolve;
    setTimeout(() => reject(new Error('Timeout loading screenshot image')), 5000);
    img.src = base64Str;
  });
  return img;
}

async function obscureImage(base64Str) {
  const img = await loadScreenshotImage(base64Str);
  const scale = SENSITIVE_SCREENSHOT_MAX_DIMENSION / Math.max(img.width, img.height);
  const downscaledCanvas = document.createElement('canvas');
  downscaledCanvas.width = Math.round(img.width * scale);
  downscaledCanvas.height = Math.round(img.height * scale);
  const downscaledCtx = downscaledCanvas.getContext('2d');
  downscaledCtx.imageSmoothingEnabled = true;
  downscaledCtx.imageSmoothingQuality = 'high';
  downscaledCtx.drawImage(img, 0, 0, downscaledCanvas.width, downscaledCanvas.height);

  const canvas = document.createElement('canvas');
  canvas.width = img.width;
  canvas.height = img.height;
  const ctx = canvas.getContext('2d');
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = 'high';
  ctx.filter = 'blur(2rem)';
  ctx.drawImage(downscaledCanvas, 0, 0, canvas.width, canvas.height);
  return canvas.toDataURL(SCREENSHOT_FORMAT, SCREENSHOT_QUALITY);
}

async function obscureCapturedScreenshot(imageData) {
  const imageDataUrl = await obscureImage(imageData.imageDataUrl);
  if (!imageData.images) {
    return { ...imageData, imageDataUrl };
  }

  const images = imageData.images.length === 1 && imageData.images[0] === imageData.imageDataUrl
    ? [imageDataUrl]
    : await Promise.all(imageData.images.map(obscureImage));
  return { ...imageData, imageDataUrl, images };
}

async function resizeImage(base64Str, maxWidth = 400, maxHeight = 350) {
  const canvas = document.createElement('canvas');
  canvas.width = maxWidth;
  canvas.height = maxHeight;

  const img = await loadScreenshotImage(base64Str);

  let width = img.width;
  let height = img.height;

  if (width > height) {
    if (width > maxWidth) {
      height *= maxWidth / width;
      width = maxWidth;
    }
  } else if (height > maxHeight) {
    width *= maxHeight / height;
    height = maxHeight;
  }

  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0, width, height);
  return canvas.toDataURL(SCREENSHOT_FORMAT, THUMBNAIL_QUALITY);
}

const doScreenshotInner = async () => {
  console.log('🐕‍🦺 Doing screenshot');
  const capturedTimeSlot = state.activeTimeSlot;
  const newTimeSlot = scheduleNextScreenshot(null);
  const now = trackingContext.nowUTC;
  capturedTimeSlot.capturedAt = now.toISOString();
  capturedTimeSlot.inputScore = 0;

  capturedTimeSlot.hash = BUILT_APP_HASH;

  if (window.APP_TRON) {
    capturedTimeSlot.titlesList = state.windows ?? {};
    capturedTimeSlot.capturedTitle = state.capturedTitle ?? 'No title';
    state.windows = {};
    state.capturedTitle = '';
  } else {
    capturedTimeSlot.titlesList = {};
    capturedTimeSlot.capturedTitle = 'inBrowser';
  }


  const sentSlot = {
    ...capturedTimeSlot,
  };

  delete sentSlot.data;
  delete sentSlot.capturedAt;

  state.capturedTitle = 'No windows captured';
  // local update for offline
  let ttbu = state.task.taskTrackedByUsers.find(t => t.userId === state.user.id);
  if (!ttbu) {
    console.log('🔴🔴🔴 No ttbu for task in doScreenshot');
    return null;
  }
  ttbu = {
    ...ttbu,
  };
  delete ttbu.timeSlots;
  ttbu.totalSeconds += sentSlot.actualTimeSeconds;

  publishLocal({
    event: 'updateTTBU',
    data: {
      ttbu,
    },
  });
  publishLocal({
    event: 'updateTimeSlot',
    note: 'new timeslot on doScreenshot',
    data: newTimeSlot,
  });

  callAPIPersisted('completeTimeSlot', {
    timeSlot: sentSlot,
    newTimeSlot,
    source: 'doScreenshot',
  });

  const sensitiveScreenshot = SENSITIVE_SCREENSHOT_ROUTES.has(router.currentRoute.value.name);
  let imageData = await (async () => {
    if (state.screenshotsEnabled === undefined) {
      console.error("state.screenshotsEnabled become undefined. Please pass true"+
        "or false, this means lack of parameter in some resume function");
      return [];
    }
    if (!state.screenshotsEnabled) {
      return [];
    }
    if (window.APP_TRON) {
      return await electronFullScreenScreenshot();
    } else {
      return await fullScreenScreenshot();
    }
  })();
  if (state.screenshotsEnabled && sensitiveScreenshot) {
    imageData = await obscureCapturedScreenshot(imageData);
  }
  const smallData =
    state.screenshotsEnabled && (await resizeImage(imageData.imageDataUrl, 480, 300));
  capturedTimeSlot.data = state.screenshotsEnabled && imageData.imageDataUrl;
  capturedTimeSlot.smallData = state.screenshotsEnabled && smallData;

  console.log('idle test!', state.idle.detector);
  console.log('activity test!', state.idle.activity);

  if (state.idle.detector.userState === 'idle') {
    console.log('user is idle!', IDLE_TIME / 60000);
    capturedTimeSlot.accepted = false;
    store.dispatch('task/saveScreenshot', {
      timeSlot: {
        ...capturedTimeSlot,
        taskTrackedByUsers: state.task?.taskTrackedByUsers,
      },
      source: 'idle-detected',
    });
    store.dispatch('task/stopTracking', { action: 'idle' });
    return undefined;
  }

  if (window.APP_TRON) {
    // we can allow better notifications here

    const task = store.state.task?.activeTrackingTask;
    if (!task) {
      return;
    }
    ipcRenderer.send('capturedScreen', {
      ...capturedTimeSlot,
      input: capturedTimeSlot.input ? JSON.parse(JSON.stringify(capturedTimeSlot.input)): capturedTimeSlot.input,
      titlesList: capturedTimeSlot.titlesList ? JSON.parse(JSON.stringify(capturedTimeSlot.titlesList)) : capturedTimeSlot.titlesList,
      images: imageData.images,
      taskName: task.textMD,
      taskHid: task.hid,
      projectName: task.project.name,
      taskTrackedByUsers: task.taskTrackedByUsers ? JSON.parse(JSON.stringify(task.taskTrackedByUsers)) : task.taskTrackedByUsers, // JSON.parse(JSON.stringify( is a hack to "Unproxy" objects, this is not compatible with ipcRenderer.send, TODO: dont buuble up proxies at all, unproxy early
      assigneeId: task.assigneeId,
      localTask: task.local,
      checklist: task.checklist,
      taskEstimate: task.estimate,
    });
  } else {
    window.rejectedLastScreenshot = false;
    try {
      window.activeSw && await window.activeSw.showNotification('Screenshot proved a work', {
        actions: [
          {
            action: 'ok',
            title: 'OK',
          },
          {
            action: 'reject',
            title: 'Reject',
          },
        ],
        body: `Press reject to cancel last ${Math.round(
          capturedTimeSlot.actualTimeSeconds / 60.0,
        )} minutes and remove screenshot`,
        tag: 'confirm-screenshot',
        renotify: true,
        silent: true, // on windows it is very uncomfortable sound
        image: state.screenshotsEnabled && imageData,
        icon: state.screenshotsEnabled && smallData,
        // icon: ''  // todo provide option to select small/large
      });
    } catch (e) {
      console.log('🔴🔴🔴 error in doScreenshot =>', e);
    }

    // we need to wait this time to allow user to reject screenshot
    // todo we need instead call this api instantly but then remove screenshot from s3 if rejected
    await new Promise((resolve) => setTimeout(resolve, 20_000));

    capturedTimeSlot.accepted = !window.rejectedLastScreenshot;
    store.dispatch('task/saveScreenshot', {
      timeSlot: {
        ...capturedTimeSlot,
        taskTrackedByUsers: state.task?.taskTrackedByUsers,
      },
      source: 'doScreenshot timeout',
    });
  }

  return undefined;
};

doScreenshot = doScreenshotInner;

window.dev = {
  doTestScreenshot() {
    doScreenshot().catch(e => {
      console.log('🔴🔴🔴 doScreenshot failed, skipping this screenshot =>', e);
    });
  },
  openAllDevTools() {
    if (window.APP_TRON) {
      ipcRenderer.send('openDevToolsForAllWindows');
    }
  }
};

const setLastTimeSlot = activeTimeSlot => {
  state.activeTimeSlot = activeTimeSlot;
};

const getActiveTimeSlot = () => state.activeTimeSlot;

const activateTracking = async ({ task, user, prevTimeSlot, changedTask, enableScreenshots }) => {
  console.log('🐕‍🦺 activate Tracking', task);
  const isElectronWaylandTracking = enableScreenshots
    && window.APP_TRON?.isWayland;

  const isElectronMacTracking = enableScreenshots
    && window.APP_TRON
    && window.devicePlatform === 'darwin';

  if (isElectronWaylandTracking) {
    // Wayland approval must happen before tracking is considered started, and the
    // approved stream is then reused for every screenshot until tracking stops.
    try {
      await initializeElectronDisplayStream();
    } catch (e) {
      console.log('Error getTronDisplayMedia 💻', e);
      stopDisplayStream();
      return 'CANCEL';
    }
  }

  if (enableScreenshots && (!window.APP_TRON || isElectronMacTracking)) {
    // Browser and macOS Electron use getDisplayMedia and keep a single approved
    // stream alive for the full tracking session.
    try {
      const displayStream = await initializeNativeDisplayStream();
      if (displayStream === 'RETRY') {
        return 'RETRY';
      }
    } catch (e) {
      console.log('Error getDisplayMedia 💻', e);
      console.log('🩺SCAP_DIAG getDisplayMedia FAILED: name=', e?.name, 'message=', e?.message);
      return 'CANCEL';
    }

    // Windows and Linux non-Wayland keep using the legacy per-screenshot path
    // that captures available screens separately and merges them on demand.
    // no stream approval is needed for that, so we don't keep stream alive during tracking for that platforms
  }

  state.screenshotsEnabled = enableScreenshots;

  state.task = task;
  state.user = user;

  idleController(START_IDLE);
  state.idle.takeLastIdle = true;
  return scheduleNextScreenshot(prevTimeSlot);
};

const deactivateTracking = (changedTask, trigger, action) => {
  clearInterval(state.slotProgresses);

  if (!changedTask) {
    stopDisplayStream();
  }

  idleController(STOP_IDLE);
  if (state.activeTimeSlot) {
    state.activeTimeSlot.titlesList = state.windows ?? {};
  }
  state.task = null;
  return state.activeTimeSlot;
};

if (window.APP_TRON) {
  window.getCookie = () => ipcRenderer.send('getCookieInApp');
}

export default {
  initializeTracking,
  electronFullScreenScreenshot,
  fullScreenScreenshot,
  activateTracking,
  deactivateTracking,
  setLastTimeSlot,
  getActiveTimeSlot,
  checkNotifyPermission,
  checkIdlePermission,
};
